<script setup lang="ts">
import { defineProps, defineEmits, ref, reactive } from 'vue';
const {t} = useI18n()

const brevoErrorWrongEmail = computed(() => t('brevoErrorWrongEmail'))
const brevoErrorSome = computed(() => t('brevoErrorSome'))
const brevoErrorEmailMissing = computed(() => t('brevoErrorEmailMissing'))

const props = defineProps<{
  isLocked: boolean;
  gameCode: string;
  trail: string;
}>();

const emit = defineEmits(['unlock']);
const errorMessage = ref<string>('');

const state = reactive({
  email: undefined,
});

async function unlock() {
  errorMessage.value = ''; // Reset error message
  if (state.email) {
    try {
      const { error, data: data } = await useFetch(`/api/brevo?email=${state.email as string}&gameCode=${props.gameCode}&trail=${props.trail}`);
      if (data.value && data.value.success) {
        emit('unlock');
      } else {
        errorMessage.value = brevoErrorWrongEmail.value;
        console.log('Failed to unlock:', error);
      }
    } catch (error) {
      errorMessage.value = brevoErrorSome.value;
      console.error('Failed to unlock:', error);
    }
  } else {
    errorMessage.value = brevoErrorEmailMissing.value;
    console.error('Email is required');
  }
}
</script>

<template>
  <div class="relative">
    <div :class="isLocked ? 'h-[85vh] overflow-hidden' : ''">
      <slot></slot>
    </div>
    <Transition>
      <div v-if="isLocked" class="fixed inset-0 z-40 bg-gradient-to-b from-stone-950/40 to-stone-950/80 backdrop-blur-sm"></div>
    </Transition>
    <Transition>
      <div v-if="isLocked" class="fixed inset-x-0 bottom-0 z-50 border-t border-stone-200 bg-white px-5 pb-8 pt-7">
        <div class="mx-auto max-w-md">
          <UForm :state="state" @submit="unlock" class="text-center">
            <h3 class="text-lg font-bold text-stone-900">{{ $t("overlayLockedText") }}</h3>
            <UInput v-model="state.email" size="lg" color="white" variant="outline" :placeholder="$t('overlayEmailPlaceholder')" class="mt-4" />
            <p v-if="errorMessage" class="mt-3 text-sm text-red-500">{{ errorMessage }}</p>
            <UButton size="lg" class="mt-4 justify-center" block type="submit">{{ $t("overlayUnlockButton") }}</UButton>
          </UForm>
        </div>
      </div>
    </Transition>
  </div>
</template>

<style scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
